export const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const REACT_APP_BASE_URL_FORM = 'https://bpm-form-api.server247.info/api'
export const UPLOADS_URL = window.__RUNTIME_CONFIG__.REACT_APP_BASE_URL
export const CLIENT_TOKEN = window.__RUNTIME_CONFIG__.REACT_CLIENT_PUBLIC_TOKEN